import { render, staticRenderFns } from "./SelectionSwitch.vue?vue&type=template&id=557fed39&scoped=true&"
import script from "./SelectionSwitch.vue?vue&type=script&lang=js&"
export * from "./SelectionSwitch.vue?vue&type=script&lang=js&"
import style0 from "./SelectionSwitch.vue?vue&type=style&index=0&id=557fed39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557fed39",
  null
  
)

export default component.exports